import React, { InputHTMLAttributes } from 'react';
import styles from './styles.module.css';

export interface RadioButtonProps
  extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  name: string;
  error?: string;
  testId?: string;
}

export const RadioButton = React.forwardRef<HTMLInputElement, RadioButtonProps>(
  ({ className, label, name, error, onChange, testId, ...rest }, ref) => {
    const baseTestId = testId || `radio-${name}`;
    return (
      <div className={className} data-testid={`${baseTestId}-root`}>
        <div className={styles.ccRadioButtonWrapper} data-testid={`${baseTestId}-wrapper`}>
          <input
            id={name}
            name={name}
            type="radio"
            ref={ref}
            data-testid={`${baseTestId}-input`}
            className={styles.ccRadioButton}
            onChange={onChange}
            {...rest}
          />

          <label htmlFor={name} className={styles.ccRadioButtonLabel} data-testid={`${baseTestId}-label`}>
            {label}
          </label>
        </div>

        {error && <p className={styles.ccRadioButtonError} data-testid={`${baseTestId}-error`}>{error}</p>}
      </div>
    );
  }
);

RadioButton.displayName = 'RadioButton';
